const KEY = 'adminEventsPanel.open';
const POS_KEY = 'adminEventsPanel.pos';

export const isEventsPanelOpen = (): boolean => {
  try {
    return sessionStorage.getItem(KEY) === 'true';
  } catch {
    return false;
  }
};

export const setEventsPanelOpen = (open: boolean): void => {
  try {
    sessionStorage.setItem(KEY, String(open));
  } catch {
    // sessionStorage unavailable (private browsing)
  }
};

export const getPanelPos = (): { x: number; y: number } | null => {
  try {
    const saved = sessionStorage.getItem(POS_KEY);
    if (!saved) return null;
    const parsed: unknown = JSON.parse(saved);
    if (
      parsed !== null &&
      typeof parsed === 'object' &&
      typeof (parsed as Record<string, unknown>).x === 'number' &&
      typeof (parsed as Record<string, unknown>).y === 'number'
    ) {
      return parsed as { x: number; y: number };
    }
    return null;
  } catch {
    return null;
  }
};

export const setPanelPos = (pos: { x: number; y: number }): void => {
  try {
    sessionStorage.setItem(POS_KEY, JSON.stringify(pos));
  } catch {
    // sessionStorage unavailable (private browsing)
  }
};
